var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-carousel',{attrs:{"height":300,"width":"100%"}},_vm._l((_vm.substeps),function(substep,i){return _c('v-carousel-item',{key:i},[_c('step',{attrs:{"step":substep}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }